// src/pages/RecruitmentAnalytics/components/TimeToHireChart.tsx
import React from 'react';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';

interface Props {
  data: { _id: { date: string }; applications: number; hires: number }[];
}

const TimeToHireChart: React.FC<Props> = ({ data }) => {
  return (
    <div style={{ width: '100%', height: 250 }}>
      <ResponsiveContainer>
        <LineChart data={data}>
          <CartesianGrid strokeDasharray="3 3" stroke="rgba(0,0,0,0.05)" />
          <XAxis dataKey="_id.date" tick={{ fontSize: 10 }} />
          <YAxis />
          <Tooltip />
          <Line type="monotone" dataKey="applications" stroke="#2575fc" strokeWidth={3} dot={{ r: 2 }} name="Заявки" />
          <Line type="monotone" dataKey="hires" stroke="#2ecc71" strokeWidth={3} dot={{ r: 2 }} name="Наймы" />
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
};

export default TimeToHireChart;